import styled from 'styled-components';
import LazyImage from '../../components/LazyImage/LazyImage';
import theme from 'shared/assets/style/theme';
import { isAndroid, isMobile, isTablet } from 'react-device-detect';

const LoyaltyPointsLogo = styled.img`
  height: 4rem;
  width: 4rem;
  object-fit: contain;
  ${({ theme }) => theme.VIPItem.LoyaltyPointsLogo}
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    height: 3.1vw;
    width: 3.1vw;
  `}
`;

const ItemPrice = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  @media screen and (max-width: 1550px) {
    font-size: 1.3rem;
  }
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    font-size: 1.25vw;
  `}
`;

const PlusLoyaltyText = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  @media screen and (max-width: 1550px) {
    font-size: 1.3rem;
  }
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    font-size: 1.15vw;
  `}
`;

const VipPackageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['windowHeight'].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  gap: 0.4rem;
  width: 28%;
  max-width: 260px;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 360px;
    min-height: 400px;
  }
  ${({ theme }) => theme.breakpoints.up('xl')} {
    max-width: 340px;
    min-height: 440px;
  }
  ${({ theme }) => theme.breakpoints.only('xxl')} {
    max-width: 330px;
    min-height: 480px;
  }

  ${({ theme }) =>
    theme.screens.device('mobile-standalone') &&
    `
    width: 30%;
    min-height: unset!important;
  `}

  ${({ theme, windowHeight }) =>
    theme.screens.device('mobile-standalone') &&
    theme.platform('android') &&
    `
    min-height: ${windowHeight > 690 ? '50vh' : 'unset'} !important;
  `}

  ${({ theme, windowHeight }) =>
    theme.screens.device('mobile-browser') &&
    !theme.platform('android') &&
    `
    gap: ${windowHeight > 690 ? 0.5 : 0.3}rem;
    width: 30%;
    max-width: 290px !important;
    min-height: unset!important;
    margin-top: ${windowHeight > 690 ? 1.5 : 0}rem;
  `}

  ${({ theme, windowHeight }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    gap: ${windowHeight > 690 ? 0.5 : 0.1}rem;
    width: 30%;
    max-width: ${windowHeight > 690 ? 240 : 290}px !important;
    min-height: unset!important;
    margin-top: ${windowHeight > 690 ? 1.5 : 0}rem;
  `}

  ${({ theme, windowHeight }) =>
    theme.screens.devices(['tablet-browser']) &&
    `
    gap: 0.2rem;
    min-height: ${windowHeight > 790 ? '370px' : 'unset'};
    margin-top: ${windowHeight > 790 ? 1 : 0}rem;
    width: 30%;
  `}
  ${({ theme, windowHeight }) =>
    theme.screens.devices(['tablet-standalone']) &&
    `
    gap: ${windowHeight > 920 ? '0.2' : '0.1'}rem;
    min-height: unset;
    height: ${windowHeight > 920 ? '370px' : '320px'};
    margin-top: 0rem;
    width: 30%;
  `}
  padding: 1rem 0.5rem;
  border-radius: 10px;
  border: 2px solid transparent;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.2),
    inset 2px 2px 6px rgba(255, 255, 255, 0.08),
    inset -2px -2px 6px rgba(0, 0, 0, 0.25);

  ${({ theme }) => theme.VIPItem.VipPackageContainer}
`;

const LogoWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['windowHeight'].includes(prop),
})`
  display: flex;
  width: 100%;
  height: 90px;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
   height: 65px;
  `}
  ${({ theme, windowHeight }) =>
    theme.screens.device('tablet-browser') &&
    `
   height: ${windowHeight > 790 ? 80 : 60}px;
  `}
  justify-content: center;
  align-items: center;
  position: relative;
`;

const LogoImage = styled(LazyImage)`
  width: 200px;
  position: absolute;
  ${({ theme }) => theme.breakpoints.up('xl')} {
    width: ${!isMobile ? 250 : 200}px;
  }
  ${({ theme }) => theme.VIPItem.LogoImage}
`;

const PackageTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  ${isMobile &&
  `
    gap: 0.1rem;
  `}
  justify-content: center;
`;

const DurationText = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  padding: 0px;
  margin: 0px;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    font-size: 1.3vw;
  `}
`;

const PackageTitleText = styled.h6`
  font-size: 1.2rem;
  font-weight: 400;
  padding: 0px;
  margin: 0px;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    theme.platform('android') &&
    `
    font-size: 1.1vw;
  `}
`;

const PlusOfferWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
  width: 60%;
`;

const PlusLogoAndAmountContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PackagePriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
`;

const BuyButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Divider = styled.div`
  width: 80%;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);
  box-shadow: 0 4px 10px rgba(255, 255, 255, 0.3);
  margin: 0;
  ${({ theme }) => theme.VIPItem.Divider}
`;

const PlusOfferContainet = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const positionStyles = isTablet
  ? { top: '-7%', right: '-12px', bottom: '-7%', left: '-12px' }
  : { top: '29px', right: '0px', bottom: '29px', left: '0px' };

const Styles = {
  buyButtonImage: {
    width: '70%',
    height: '2.5rem',
    cursor: 'pointer',
  },
  vipPackageBuyButtonImage: {
    width: isMobile && isAndroid ? '9vw' : '9rem',
    height: isMobile && isAndroid ? '6vh' : '3rem',
    cursor: 'pointer',
  },
  buyButtonStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'auto',
    height: '4rem',
  },
  buyButtonText: {
    fontSize: '26px',
  },
  vipPackageBuyButtonStyle: {
    width: isMobile && isAndroid ? '9vw' : '9rem',
    height: isMobile && isAndroid ? '6vh' : '3rem',
  },
  tileInnerStyle: {
    ...positionStyles,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common[1],
  },
};

export {
  LoyaltyPointsLogo,
  ItemPrice,
  PlusLoyaltyText,
  VipPackageContainer,
  LogoWrapper,
  LogoImage,
  PackageTitleWrapper,
  DurationText,
  PackageTitleText,
  PlusLogoAndAmountContainer,
  PlusOfferContainet,
  PlusOfferWrapper,
  PackagePriceWrapper,
  BuyButtonWrapper,
  Divider,
  Styles,
};

